import { fromUnixTime } from 'date-fns';
import { useMemo } from 'react';

import { EventType } from '@lib/types';
import { getEventStatus } from '@lib/utils';

import { ENTER_ROOM_TIME_OFFSET } from '../../constants';

type Props = {
  event: EventType;
};

const useEventStatus = ({ event }: Props) => {
  const eventStatus = useMemo(() => {
    const eventState = getEventStatus({
      startedAt: event.startedAt,
      endedAt: event.endedAt,
    });

    return eventState.status;
  }, [event]);

  const eventTimeOffset = useMemo(() => {
    if (!event) {
      return;
    }

    const currentTime = new Date();
    const startTime = fromUnixTime(event.startedAt);

    return startTime.getTime() - currentTime.getTime();
  }, [event]);

  const isEventOngoing = eventStatus === 'ongoing';
  const isEnabledToEnterRoom =
    eventTimeOffset &&
    eventStatus === 'upcoming' &&
    eventTimeOffset < ENTER_ROOM_TIME_OFFSET;

  return {
    eventStatus,
    eventTimeOffset,
    isEventOngoing,
    isEnabledToEnterRoom,
  };
};

export default useEventStatus;
